import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquarePollVertical,
  faTimeline,
  faQuestion,
  faGears,
  faTableColumns,
  faUser,
  faMagnifyingGlass,
  faToolbox,
  faBook,
  faGraduationCap
} from "@fortawesome/free-solid-svg-icons";

export const pageRoutes = {
  guest: [
    {
      id: 1,
      title: "Profile",
      icon: <FontAwesomeIcon icon={faTableColumns} />,
      link: "/candidate/profile",
    },
  ],
  candidate: [
    // {
    //   id: 1,
    //   title: "Dashboard",
    //   icon: <FontAwesomeIcon icon={faTableColumns} />,
    //   link: "/candidate/dashboard",
    //   slug: "dashboard",
    // },
    // {
    //   id: 1,
    //   title: "Applications",
    //   icon: <FontAwesomeIcon icon={faBook} />,
    //   link: "/candidate/application",
    //   slug: "applications",
    // },
    // {
    //   id: 2,
    //   title: "Practice Exams",
    //   icon: <FontAwesomeIcon icon={faGraduationCap} />,
    //   link: "/candidate/assessments/view-practice-exams",
    //   slug: "practice-exams",
    // },
    {
      id: 3,
      title: "Upcoming Exams",
      icon: <FontAwesomeIcon icon={faSquarePollVertical} />,
      link: "/candidate/assessments/view-assessments",
      slug: "upcoming-exams",
    },
    {
      id: 4,
      title: "Exam History",
      icon: <FontAwesomeIcon icon={faTimeline} />,
      link: "/candidate/exam-history",
      slug: "exam-history",
    },
    // {
    //   id: 5,
    //   title: "My Profile",
    //   icon: <FontAwesomeIcon icon={faUser} />,
    //   link: "/candidate/profile",
    //   slug: "my-profile",
    // },
    // {
    //   id: 6,
    //   title: "Help & Documentation",
    //   icon: <FontAwesomeIcon icon={faQuestion} />,
    //   link: "/candidate/documentation",
    // },
    // {
    //   id: 4,
    //   title: "Vacancies",
    //   icon: <FontAwesomeIcon icon={faToolbox} />,
    //   link: "/candidate/vacancies",
    // },

    // {
    //   id: 6,
    //   title: "Settings",
    //   icon: <FontAwesomeIcon icon={faGears} />,
    //   link: "/candidate/settings",
    //   info: "View profile",
    //   slug: "settings",
    // },
  ],
};
